import React from 'react';
import NavigateNext from '@mui/icons-material/NavigateNext';
import styles from './DraftBlockMobile.module.scss';
import { Button } from 'tt-ui-lib/core';
import { LitterBinIcon } from 'tt-ui-lib/icons';
import RenameInput from '../ReportRename/ReportRename';
import Menu3Dot from '../Menu3Dot/Menu3Dot';

const DraftBlockMobile = ({ props }) => {
  const {
    draft,
    targetWidth,
    calcLogo,
    editId,
    setEditId,
    onProceedDraft,
    onDelete,
    onRenameDraft,
    onBuyCredits,
  } = props;

  const menuItems = [
    {
      key: 'pay',
      label: 'Pay',
      onClick: () => onBuyCredits(draft.id),
      disabled: !draft.canPay,
    },
    {
      key: 'delete',
      label: 'Delete',
      onClick: () => onDelete(draft),
      disabled: !draft.canPay || !onDelete,
    },
  ];

  return (
    <>
      <div key={draft.id} className={styles.rowWrapper}>
        <div className={styles.first}>
          <div className={styles.draftName}>
            {/* {calcLogo && <div className={styles.logo}>{calcLogo}</div>} */}
            <RenameInput
              id={draft.id}
              name={draft.name}
              onEditClick={() => setEditId(editId === draft.id ? null : draft.id)}
              onEditFinish={onRenameDraft}
              isEditing={editId === draft.id}
            />
          </div>
          <Menu3Dot items={menuItems} />
        </div>
        <div className={styles.info}>
          <div className={styles.container}>
            <p className={styles.dataSecond}>Edited:</p>
            <p className={styles.dataValue}>
              {draft?.updatedAt ? draft.updatedAt.toLocaleDateString() : ''}
            </p>
          </div>
          <div className={styles.container}>
            <p className={styles.dataSecond}>Created:</p>
            <p className={styles.dataValue}>
              {draft?.createdAt ? draft.createdAt.toLocaleDateString() : ''}
            </p>
          </div>
        </div>
        <div className={styles.buttonCont}>
          <Button
            className={styles.payBtn}
            onClick={() => onBuyCredits(draft.id)}
            disabled={!draft.canPay}
          >
            Proced
          </Button>
        </div>
      </div>
    </>
  );
};

export default DraftBlockMobile;
